import React, { useEffect, useState } from "react";
import axios from "axios";
import jsPDF from "jspdf";
import "./formStyles.css";

/* ─── Scoped styles for the redesigned modal only ──────────────────────────── */
const InternRegistration = () => {
  const backendUrl = process.env.REACT_APP_DATABASEURL;
  const [showSuccess, setShowSuccess] = useState(false);

  const [ongoingEvent, setongoingEvent] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const today = new Date();

  const RandomId = () => {
    const pad = (num) => String(num).padStart(2, "0");
    const year = String(today.getFullYear()).slice(-2);
    const month = pad(today.getMonth() + 1);
    const day = pad(today.getDate());
    const hour = pad(today.getHours());
    const minute = pad(today.getMinutes());
    const second = pad(today.getSeconds());
    return `${year}${month}${day}${hour}${minute}${second}`;
  };

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const res = await axios.get(`${backendUrl}/api/get-gateway-events`);

        const events = res.data?.event_data || [];

        setongoingEvent(events);
      } catch (err) {
        console.error("Error fetching events:", err);
      }
    };

    fetchEvents();
  }, [backendUrl]);

  const handleRegisterClick = (event) => {
    setSelectedEvent(event);

    setFormData((prev) => ({
      ...prev,
      event_name: event.event_name,
      event_amount: event.event_amount,
    }));

    setShowPopup(true); // open modal
  };

  const id = RandomId();

  const [formData, setFormData] = useState({
    applicationId: id,
    branch: "",
    email: "",
    rollNo: "",
    projectTitle: "",
    guideName: "",
    participantName: "",
    contactNo: "",
    otherDepartment: "",
    event_name: "",
    event_amount: "",
    collegeAddress: "Suramplem",
  });

  // const finalPhone = `${formData.countryCode}${formData.contactNo}`;
  const finalPhone = `${formData.nationality === "India" ? "+91" : formData.countryCode}${formData.contactNo}`;
  const [paymentStatus, setPaymentStatus] = useState(null);
  const { event_amount } = formData;

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const createOrder = async (orderAmount, currency) => {
    console.log("orderAmount", orderAmount);
    try {
      const response = await axios.post(
        `${backendUrl}/payment-events/create-order`,
        {
          amount: orderAmount,
          currency: currency,
          receipt: `receipt_${Date.now()}`,
          notes: { description: "Event Registration" },
        },
      );
      const data = await response.data;
      if (!data.success)
        throw new Error(data.message || "Failed to create order");
      return data;
    } catch (error) {
      console.error("Error creating order:", error);
      throw error;
    }
  };

  const downloadReceipt = () => {
    if (!paymentStatus || !paymentStatus.receiptData) return;
    const { receiptData, paymentId } = paymentStatus;
    const doc = new jsPDF();
    const receiptDate = new Date().toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
    const primaryColor = [12, 106, 176];
    const secondaryColor = [76, 175, 80];
    const textColor = [51, 51, 51];

    doc.setFillColor(...primaryColor);
    doc.rect(0, 0, 210, 40, "F");
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(24);
    doc.setFont("helvetica", "bold");
    doc.text("ADITYA UNIVERSITY", 105, 18, { align: "center" });
    doc.setFontSize(14);
    doc.setFont("helvetica", "normal");
    doc.text("Receipt", 105, 28, { align: "center" });
    doc.setTextColor(...textColor);
    doc.setFontSize(9);
    doc.setFont("helvetica", "normal");
    doc.text(`Receipt Date: ${receiptDate}`, 20, 50);
    doc.text(`Application ID: ${receiptData.applicationId}`, 20, 56);
    doc.setDrawColor(200, 200, 200);
    doc.line(20, 62, 190, 62);

    let yPos = 72;
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(...primaryColor);
    doc.text("PARTICIPANT DETAILS", 20, yPos);
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(...textColor);
    [
      ["Name:", `${receiptData.participantName}`],
      ["Email:", receiptData.email],
      ["Contact No:", receiptData.contactNo],
      ["Department:", receiptData.branch],
    ].forEach(([label, val]) => {
      yPos += 6;
      doc.text(label, 20, yPos);
      doc.text(String(val), 60, yPos);
    });

    // yPos += 8;
    // doc.setDrawColor(200, 200, 200);
    // doc.line(20, yPos, 190, yPos);
    // yPos += 8;
    // doc.setFontSize(12);
    // doc.setFont("helvetica", "bold");
    // doc.setTextColor(...primaryColor);
    // doc.text("ORGANIZATION DETAILS", 20, yPos);
    // doc.setFontSize(10);
    // doc.setFont("helvetica", "normal");
    // doc.setTextColor(...textColor);
    // yPos += 8;
    // doc.text("College/Institute:", 20, yPos);
    // const collegeLines = doc.splitTextToSize(receiptData.collegeName, 120);
    // doc.text(collegeLines, 60, yPos);
    // yPos += collegeLines.length * 6;
    // doc.text("Address:", 20, yPos);
    // const addrLines = doc.splitTextToSize(receiptData.collegeAddress, 120);
    // doc.text(addrLines, 60, yPos);
    // yPos += addrLines.length * 6;
    // doc.text("State:", 20, yPos);
    // doc.text(String(receiptData.state), 60, yPos);

    yPos += 8;
    doc.setDrawColor(200, 200, 200);
    doc.line(20, yPos, 190, yPos);
    yPos += 8;
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(...primaryColor);
    doc.text("EVENT DETAILS", 20, yPos);
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(...textColor);
    yPos += 8;
    doc.text("Event Name:", 20, yPos);
    const evLines = doc.splitTextToSize(receiptData.event_name, 120);
    doc.text(evLines, 60, yPos);
    yPos += evLines.length * 6;
    doc.text("Event Amount:", 20, yPos);
    doc.setFont("helvetica", "bold");
    doc.text(String(receiptData.event_amount), 60, yPos);
    doc.setFont("helvetica", "normal");

    yPos += 8;
    doc.setDrawColor(200, 200, 200);
    doc.line(20, yPos, 190, yPos);
    yPos += 8;
    doc.setFillColor(...secondaryColor);
    doc.rect(18, yPos - 5, 174, 32, "F");
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(255, 255, 255);
    doc.text("PAYMENT DETAILS", 20, yPos);
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    yPos += 8;
    doc.text("Payment Status:", 20, yPos);
    doc.setFont("helvetica", "bold");
    doc.text("SUCCESS", 60, yPos);
    doc.setFont("helvetica", "normal");
    yPos += 6;
    doc.text("Payment ID:", 20, yPos);
    doc.text(String(paymentId), 60, yPos);
    yPos += 6;
    doc.text("UTR ID:", 20, yPos);
    doc.text(String(receiptData.utr), 60, yPos);
    yPos += 6;
    doc.text("Amount Paid:", 20, yPos);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.text(String(receiptData.event_amount), 60, yPos);

    doc.setFontSize(8);
    doc.setFont("helvetica", "italic");
    doc.setTextColor(100, 100, 100);
    doc.text("Thank you for registering with Aditya University!", 105, 270, {
      align: "center",
    });
    doc.text(
      "For queries, contact: ala@adityauniversity.in | https://adityauniversity.in/",
      105,
      276,
      { align: "center" },
    );
    doc.setDrawColor(...primaryColor);
    doc.setLineWidth(0.5);
    doc.rect(10, 10, 190, 277);
    doc.save(`Receipt_${receiptData.applicationId}_${paymentId}.pdf`);
  };

  const finalDesignation =
    formData.designation === "Other"
      ? formData.otherDesignation
      : formData.designation;
  const finalDepartment =
    formData.branch === "Other" ? formData.otherDepartment : formData.branch;

  const resetForm = () => {
    setFormData({
      applicationId: RandomId(),
      branch: "",
      email: "",
      rollNo: "",
      projectTitle: "",
      guideName: "",
      participantName: "",
      contactNo: "",
      otherDepartment: "",
      event_name: "",
      event_amount: "",
      collegeAddress: "Suramplem",
    });

    setSelectedEvent(null);
  };

  const verifyPayment = async (paymentData) => {
    try {
      const response = await axios.post(
        `${backendUrl}/payment-events/verify-payment`,
        paymentData,
      );
      const data = await response.data;
      if (data.success) {
        const payload = {
          applicationId: formData.applicationId,
          participantName: formData.participantName,

          rollNo: formData.rollNo,
          branch: finalDepartment,
          projectTitle: formData.projectTitle,
          guideName: formData.guideName,

          email: formData.email,
          contactNo: formData.contactNo,

          event_name: formData.event_name,
          event_amount: formData.event_amount,

          amount: data.amount,
          order_id: data.orderId,
          payment_id: data.paymentId,
          utr: data.utr,
          payment_status: "Success",
        };

        const registrationResponse = await axios.post(
          `${backendUrl}/api/add-gateway-events-registrations`,
          payload,
        );
        setPaymentStatus({
          success: true,
          message: "Payment successful!",
          paymentId: data.paymentId,
          orderId: data.orderId,
          utr: data.utr,
          amount: data.amount,
          receiptData: payload,
        });
        if (registrationResponse.data.success === true) {
          setShowSuccess(true);
          resetForm();
          setShowPopup(false);
        } else {
          alert(
            `⚠️ Payment Success But Registration Failed! ${registrationResponse.data.message || "Please try again."}`,
          );
        }
      }
      return data;
    } catch (error) {
      console.error("Error verifying payment:", error);
      throw error;
    }
  };

  const handlePayment = async (e) => {
    e.preventDefault();
    // ── Helper: focus + highlight a field by name ──────────────────────────
    const focusField = (name) => {
      const el = document.querySelector(`[name="${name}"]`);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
        el.focus();
        el.style.borderColor = "#c0392b";
        el.style.boxShadow = "0 0 0 3px rgba(192,57,43,0.2)";
        // Reset red border after 3 seconds
        setTimeout(() => {
          el.style.borderColor = "";
          el.style.boxShadow = "";
        }, 3000);
      }
    };

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.participantName) {
      alert("❌ Participant Name is required");
      focusField("participantName");
      return;
    }
    if (!formData.rollNo) {
      alert("❌ Roll Number is required");
      focusField("rollNo");
      return;
    }
    if (!emailRegex.test(formData.email)) {
      alert("❌ Please enter a valid Email ID");
      focusField("email");
      return;
    }
    if (!formData.branch) {
      alert("❌ Department is required");
      focusField("branch");
      return;
    }
    if (formData.branch === "Other" && !formData.otherDepartment) {
      alert("❌ Please specify your Department");
      focusField("otherDepartment");
      return;
    }
    if (!formData.projectTitle) {
      alert("Project Title required");
      focusField("projectTitle");
      return;
    }
    if (!formData.guideName) {
      alert("Guide Name required");
      focusField("guideName");
      return;
    }

    // Phone validation
    const phoneRegex =
      formData.nationality === "India" ? /^[6-9]\d{9}$/ : /^\d{6,16}$/;
    if (!phoneRegex.test(formData.contactNo)) {
      alert("❌ Please enter a valid Contact Number");
      focusField("contactNo");
      return;
    }

    // ── All validations passed → proceed with payment ──────────────────────

    try {
      setLoading(true);
      setPaymentStatus(null);
      const scriptLoaded = await loadRazorpayScript();
      if (!scriptLoaded) {
        alert(
          "Failed to load Razorpay SDK. Please check your internet connection.",
        );
        setLoading(false);
        return;
      }

      // const currency = formData.nationality === "India" ? "INR" : "USD";
      const currency = "INR";
      const orderData = await createOrder(
        parseFloat(formData.event_amount),
        currency,
      );

      const options = {
        key: orderData.keyId,
        amount: orderData.order.amount,
        currency: orderData.order.currency,
        name: "Aditya University",
        description: "Event Payment",
        image:
          "https://adityauniversity.in/admin/static/media/AU_LOGO.b5e661897c751649cf1f2978c02df938.svg",
        order_id: orderData.order.id,
        handler: async function (response) {
          try {
            const verificationResult = await verifyPayment({
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
            });
            console.log("VERIFY RESULT:", verificationResult);
            console.log("SUCCESS VALUE:", verificationResult?.success);
            if (!verificationResult.success) {
              setPaymentStatus({
                success: false,
                message: "Payment verification failed!",
              });
            }
          } catch (error) {
            setPaymentStatus({
              success: false,
              message: "Payment verification error!",
            });
          }
          setLoading(false);
        },
        prefill: {
          name: formData.participantName,
          email: formData.email,
          contact: formData.contactNo,
        },
        notes: { address: formData.collegeAddress },
        theme: { color: "#3399cc" },
        modal: {
          ondismiss: function () {
            setLoading(false);
            setPaymentStatus({
              success: false,
              message: "Payment cancelled by user",
            });
          },
        },
      };
      const paymentObject = new window.Razorpay(options);
      paymentObject.open();
    } catch (error) {
      console.error("Payment error:", error);
      setPaymentStatus({
        success: false,
        message: error.message || "Payment failed!",
      });
      setLoading(false);
    }
  };

  const openPopup = (eventData) => {
    setSelectedEvent(eventData);
    setFormData({
      ...formData,
      event_amount: eventData.event_amount || "",
      event_amount_other: eventData.event_amount_other || "",
      event_name: eventData.event_name || "",
      whatsappLink: eventData.whatsappLink || "",
    });
    setShowPopup(true);
    setPaymentStatus(null);
  };

  const closePopup = () => {
    setShowPopup(false);
    setPaymentStatus(null);
    setFormData({
      applicationId: id,
      participantName: "",
      branch: "",
      email: "",
      contactNo: "",
      event_amount: "",
      event_name: "",
    });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    if (!formData.nationality) return;
    const amount =
      formData.nationality === "India"
        ? selectedEvent?.event_amount
        : selectedEvent?.event_amount_other;
    setFormData((prev) => ({ ...prev, event_amount: amount || "" }));
  }, [formData.nationality, selectedEvent]);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(8);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const handlePageChange = (page) => setCurrentPage(page);

  const eventAmountDisplay =
    formData.nationality === "India"
      ? `₹ ${selectedEvent?.event_amount || ""}`
      : formData.nationality === "Foreign"
        ? `$ ${selectedEvent?.event_amount_other || ""}`
        : "";

  return (
    <>
      <div className="back__course__page_grid react-courses__single-page pb---16">
        <div>
          <div>
            <div className="event-container">
              {ongoingEvent.map((event, index) => (
                // <div
                //   key={index}
                //   className="event-container"
                //   style={{
                //     display: "flex",
                //     gap: "20px",
                //     alignItems: "center",
                //   }}
                // >
                <div key={index} className="event-card">
                  <h2 className="hedingname_orange" style={{ margin: 0 }}>
                    {event.event_name}
                  </h2>

                  {/* <p>{event.event_description}</p> */}

                  <div className="event-actions">
                    <button
                      className="btn animation"
                      onClick={() => handleRegisterClick(event)}
                    >
                      Register Now
                    </button>
                  </div>
                  <span className="last-date">
                    Registration last date:{" "}
                    {event.reg_end_date?.split("-").reverse().join("-") ||
                      "09-04-2026"}
                  </span>
                </div>
              ))}
            </div>

            {/* ════════════════════════════════════════════
                            REDESIGNED REGISTRATION MODAL
                        ════════════════════════════════════════════ */}
            {showPopup && (
              <div className="reg-overlay">
                <div className="reg-modal">
                  {/* Header */}
                  <div className="reg-header">
                    <button
                      className="reg-close-btn"
                      type="button"
                      onClick={closePopup}
                      title="Close"
                    >
                      ✕
                    </button>
                    <center>
                      {" "}
                      <h2 className="animation">Registration</h2>{" "}
                    </center>
                    {/* <p>All fields marked * are mandatory. Name will appear exactly as entered on the certificate.</p> */}
                  </div>

                  {/* Form Body */}
                  <div className="reg-body">
                    <form onSubmit={handlePayment} id="reg-form">
                      {/* ── Personal Information ── */}
                      <div className="reg-section-label">
                        Personal Information 👤
                      </div>

                      <div className="reg-grid-2">
                        <div className="reg-field">
                          <label className="reg-field-label">
                            Participant Name <span className="req">*</span>
                          </label>
                          <input
                            className="reg-input"
                            type="text"
                            name="participantName"
                            placeholder="FULL NAME"
                            maxLength={30}
                            value={formData.participantName}
                            onChange={(e) => {
                              let value = e.target.value.toUpperCase();
                              if (
                                /^[A-Z\s]*$/.test(value) &&
                                value.length <= 30
                              ) {
                                handleChange({
                                  target: { name: "participantName", value },
                                });
                              }
                            }}
                            required
                          />
                        </div>

                        <div className="reg-field">
                          <label className="reg-field-label">
                            Roll Number <span className="req">*</span>
                          </label>
                          <input
                            className="reg-input"
                            name="rollNo"
                            placeholder="Your roll number"
                            maxLength={50}
                            value={formData.rollNo}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>

                      <div className="reg-grid-2">
                        <div className="reg-field">
                          <label className="reg-field-label">
                            Email Address <span className="req">*</span>
                          </label>
                          <input
                            className="reg-input"
                            type="email"
                            name="email"
                            placeholder="you@example.com"
                            maxLength={50}
                            value={formData.email}
                            onChange={handleChange}
                            required
                          />
                        </div>

                        <div className="reg-field">
                          <label className="reg-field-label">
                            Department <span className="req">*</span>
                          </label>
                          <select
                            className="reg-select"
                            name="branch"
                            value={formData.branch}
                            onChange={handleChange}
                            required
                          >
                            <option value="">Select Department</option>
                            {[
                              "CSE",
                              "EEE",
                              "ECE",
                              "AIML",
                              "Civil",
                              "IT",
                              "IOT",
                              "Petroleum",
                              "Mining",
                              "Agricultural",
                              "Data Science",
                              "Mechanical",
                              "MCA",
                              "MBA",
                              "Other",
                            ].map((d) => (
                              <option key={d} value={d}>
                                {d}
                              </option>
                            ))}
                          </select>
                        </div>
                        {formData.branch === "Other" && (
                          <div className="reg-field">
                            <label className="reg-field-label">
                              Specify Department <span className="req">*</span>
                            </label>
                            <input
                              className="reg-input"
                              type="text"
                              name="otherDepartment"
                              placeholder="Enter your department"
                              maxLength={30}
                              value={formData.otherDepartment || ""}
                              onChange={handleChange}
                              required
                            />
                          </div>
                        )}

                        <div className="reg-field">
                          <label className="reg-field-label">
                            Contact Number <span className="req">*</span>
                          </label>
                          <div className="reg-phone-row">
                            <div className="reg-phone-prefix">
                              {formData.nationality === "India"
                                ? "+91"
                                : formData.countryCode || "—"}
                            </div>
                            <input
                              className="reg-phone-input"
                              type="tel"
                              name="contactNo"
                              placeholder="Mobile number"
                              value={formData.contactNo}
                              onChange={(e) => {
                                const value = e.target.value.replace(/\D/g, "");
                                const maxLength =
                                  formData.nationality === "India" ? 10 : 16;
                                if (value.length <= maxLength) {
                                  setFormData((prev) => ({
                                    ...prev,
                                    contactNo: value,
                                  }));
                                }
                              }}
                              required
                            />
                          </div>
                        </div>
                      </div>

                      {/* ── Project Information ── */}
                      <div className="reg-section-label">
                        Project Information 👤
                      </div>

                      <div className="reg-grid-2">
                        <div className="reg-field">
                          <label className="reg-field-label">
                            Project Title <span className="req">*</span>
                          </label>
                          <input
                            className="reg-input"
                            type="text"
                            name="projectTitle"
                            placeholder="Project Title"
                            maxLength={120}
                            value={formData.projectTitle}
                            onChange={handleChange}
                            required
                          />
                        </div>

                        <div className="reg-field">
                          <label className="reg-field-label">
                            Guide Name <span className="req">*</span>
                          </label>
                          <input
                            className="reg-input"
                            type="text"
                            name="guideName"
                            placeholder="Your Guide name"
                            maxLength={50}
                            value={formData.guideName}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>

                      <div className="refund-alert">
                        ⚠️ <strong>Refundable</strong> registration fee 500/-
                      </div>

                      {/* ── Event Details ── */}
                      <div className="reg-section-label">Event Details 🌟</div>
                      <div className="reg-event-card">
                        <div className="reg-event-name">
                          {selectedEvent?.event_name || "—"}
                        </div>
                        <div className="reg-event-amount">
                          {`Rs.${selectedEvent?.event_amount}/-` || "—"}
                        </div>
                      </div>

                      {/* Hidden fields */}
                      <input
                        type="hidden"
                        name="whatsappLink"
                        value={selectedEvent?.whatsappLink || ""}
                      />
                    </form>
                  </div>

                  {/* Payment result */}
                  {paymentStatus && (
                    <div
                      className={`reg-payment-result ${paymentStatus.success ? "success" : "failure"}`}
                    >
                      <h3>
                        {paymentStatus.success
                          ? "✅ Payment Successful"
                          : "❌ Payment Failed"}
                      </h3>
                      {paymentStatus.paymentId && (
                        <>
                          <p>
                            <strong>Payment ID:</strong>{" "}
                            {paymentStatus.paymentId}
                          </p>
                          <p>
                            <strong>UTR No:</strong> {paymentStatus.utr}
                          </p>
                        </>
                      )}
                    </div>
                  )}

                  {/* Footer */}
                  <div className="reg-footer">
                    <button
                      type="button"
                      className="reg-btn-cancel"
                      onClick={closePopup}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      form="reg-form"
                      className="reg-btn-pay"
                      disabled={loading}
                      onClick={handlePayment}
                    >
                      {loading ? (
                        <>
                          <span className="reg-spinner" />
                          Processing…
                        </>
                      ) : (
                        "Proceed to Payment"
                      )}
                    </button>
                  </div>
                  <div className="notice-banner">
                    ⚠️ <span>Note:</span> The server will undergo maintenance
                    daily from
                    <strong> 4:00 PM to 4:30 PM</strong>. Kindly avoid
                    registrations during this period.
                  </div>
                </div>
              </div>
            )}
            {/* ── END MODAL ── */}

            {/* Success overlay */}
            {showSuccess && (
              <div className="reg-success-overlay">
                <div className="reg-success-box">
                  <span className="reg-success-icon">🎉</span>
                  <h3>Registration Successful!</h3>
                  <p>
                    Your registration is confirmed. Download your receipt below.
                  </p>
                  <button
                    className="reg-btn-download"
                    onClick={() => {
                      downloadReceipt();
                      setShowSuccess(false);
                    }}
                  >
                    📥 Download Receipt
                  </button>
                </div>
              </div>
            )}

            {/* <ScrollToTop /> */}
          </div>
        </div>
      </div>
      {/* <FooterTwo /> */}
    </>
  );
};

export default InternRegistration;
